import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import { withStyles } from '@material-ui/core';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { injectIntl } from 'react-intl';

import SettingsIcon from '@material-ui/icons/Settings';
import AssessmentTwoTone from '@material-ui/icons/AssessmentTwoTone';
import Tooltip from '@material-ui/core/Tooltip';
import SelectableAvatar from './SelectableAvatar';
import ModifiedTimeChip from '../Chips/ModifiedTimeChip';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  root: {
    padding: `${theme.spacing(1) * 2}px`,
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginRight: `${theme.spacing(1)}px`,
    },
    '& :last-child': {
      marginRight: 'unset',
    },
    '& :first-child': {
      margin: 'unset',
    },
    '&:focus': {
      backgroundColor: 'initial',
    },
  },

  actionsContainer: {
    '& > *': {
      marginRight: `${theme.spacing(1) * 2}px`,
    },
  },

  centerChildren: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
  },

  textBox: {
    paddingRight: '220px',
  },

  icon: {
    marginRight: '6px',
    fontSize: 18,
  },

  checkBox: {
    padding: 0,
  }

});

const TreeEntry = (props) => {
  const {
    classes, treeDetails, match: { params: { id, treeType } }, selected, handleChange,
    isPicker, sortRule, basePath
  } = props;

  const primaryText = (
    <Typography noWrap variant="h6" color="textPrimary">{treeDetails.title}</Typography>
  );
  const secondaryText = (description) => {
    if (!description || description === '') {
      return null;
    }
    return <Typography noWrap color="textSecondary">{description}</Typography>;
  };

  const TreeBaseName = `${basePath}/${id}/${treeType}/${treeDetails.id}`;

  const settings = (
    <Link
      to={`${TreeBaseName}/settings`}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} // className doesn't work
    >
      <Tooltip title="Settings">
        <Typography color="textSecondary" className={classes.centerChildren}>
          <SettingsIcon className={classes.icon} />
        </Typography>
      </Tooltip>
    </Link>
  );

  const results = (
    <Link
      to={`${TreeBaseName}/quantify`}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} // className doesn't work
    >
      <Tooltip title="Results">
        <Typography color="textSecondary" className={classes.centerChildren}>
          <AssessmentTwoTone className={classes.icon} />
        </Typography>
      </Tooltip>
    </Link>
  );

  const checkBox = (
    <Checkbox
      checked={selected}
      color="primary"
      onClick={e => {
        e.stopPropagation();
        handleChange(e);
      }}
      className={classes.checkBox} />
  );

  return (
    <Link
      to={{ pathname: TreeBaseName }}
      onClick={(e => isPicker && e.preventDefault())}

    >
      <ListItem
        button
        key={treeDetails.id}
        alignItems="center"
        className={!isPicker && classes.root}
        divider
        selected={selected}
        onClick={handleChange}
      >
        <ListItemAvatar>
          <SelectableAvatar
            selected={!isPicker && selected}
            onChange={handleChange}
            title={treeDetails.title}
            id={0}
          />
        </ListItemAvatar>
        <ListItemText
          className={!isPicker && classes.textBox}
          primary={isPicker ? treeDetails.title : primaryText}
          secondary={secondaryText(treeDetails.description)}
        />
        <ListItemSecondaryAction className={`${classes.actionsContainer} ${classes.centerChildren}`}>
          { !isPicker &&
          <React.Fragment>
            <ModifiedTimeChip timestamp={treeDetails.date_modified} sortRule={sortRule} />
            {settings}
            {results}
            {checkBox}
          </React.Fragment>
          }
        </ListItemSecondaryAction>
      </ListItem>
    </Link>
  );
};

TreeEntry.propTypes = {
  treeDetails: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    date_created: PropTypes.string.isRequired,
    date_modified: PropTypes.string.isRequired,
    tree_type: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string,
  }).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  selected: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  isPicker: PropTypes.bool,
  basePath: PropTypes.string,
  sortRule: PropTypes.string,
};

TreeEntry.defaultProps = {
  isPicker: false,
  basePath: '/model',
  sortRule: ''
};

export default withStyles(styles)(injectIntl(TreeEntry));
